import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../utils/config";

// Tạo async thunk để lấy danh sách dịch vụ từ API
export const getTemplates = createAsyncThunk(
  "template/getTemplates",
  async ({ currentPage, pageSize, status, branchId }, { rejectWithValue }) => {
    try {
      let apiUrl = `/api/v1/templates/management?has_paginate&size=${pageSize}&page=${currentPage}`;

      if (status) {
        apiUrl += `&status=${status}`;
      }

      if (branchId) {
        apiUrl += `&branch_id=${branchId}`;
      }

      const response = await http.get(apiUrl);
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Có lỗi xảy ra trong quá trình kết nối");
    }
  }
);

export const deleteTemplate = createAsyncThunk(
  "template/deleteTemplate",
  async (id, { rejectWithValue }) => {
    try {
      const response = await http.delete(
        `/api/v1/templates/management/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const toggleTemplateStatus = createAsyncThunk(
  "template/toggleTemplateStatus",
  async (id, { rejectWithValue }) => {
    try {
      const response = await http.patch(
        `/api/v1/templates/management/${id}/toggle-status`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const addTemplate = createAsyncThunk(
  "template/addTemplate",
  async (data, { rejectWithValue }) => {
    try {
      const response = await http.post(`/api/v1/templates/management`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateTemplate = createAsyncThunk(
  "template/updateTemplate",
  async ({id, data}, { rejectWithValue }) => {
    try {
      const response = await http.post(
        `/api/v1/templates/management/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const showTemplate = createAsyncThunk(
  "template/showTemplate",
  async ({id}, { rejectWithValue }) => {
    try {
      const response = await http.get(
        `/api/v1/templates/management/by-shop/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


// export const generateCode = createAsyncThunk(
//   "template/generateCode",
//   async (data, { rejectWithValue }) => {
//     try {
//       const response = await http.post(`/api/v1/templates/qr-code`, data, {
//         responseType: 'blob',
//         timeout: 60000
//       });
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response.data);
//     }
//   }
// );

export const generateCode = createAsyncThunk(
  "template/generateCode",
  async (data, { rejectWithValue }) => {
    try {
      const response = await http.post(`/api/v1/templates/qr-code`, data, {
        timeout: 60000
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);